import { render } from "./NodeFactField.vue?vue&type=template&id=4b253e16"
import script from "./NodeFactField.vue?vue&type=script&lang=js"
export * from "./NodeFactField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shaohuanqing/dev/kuboard-spray/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__